import gql from 'graphql-tag';

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation UpdateEmailTemplate($id: ID!, $input: UpdateEmailTemplateInput!) {
    updateEmailTemplate(id: $id, input: $input) {
      id
      name
      purpose
      subject
      body
      triggerEvent
      isActive
      updatedAt
      stats {
        id
        sentCount
        openCount
        clickCount
        bounceCount
        lastSentAt
      }
    }
  }
`;

export const SEND_EMAIL_TEMPLATE_TEST = gql`
  mutation SendEmailTemplateTest($id: ID!, $to: String!) {
    sendEmailTemplateTest(id: $id, to: $to) {
      success
      message
    }
  }
`;

export interface UpdateEmailTemplateVariables {
  id: string;
  input: {
    name?: string;
    purpose?: string;
    subject?: string;
    body?: string;
  };
}

export interface SendEmailTemplateTestVariables {
  id: string;
  to: string;
}

export interface SendEmailTemplateTestResponse {
  sendEmailTemplateTest: {
    success: boolean;
    message: string;
  };
}

export interface UpdateEmailTemplateResponse {
  updateEmailTemplate: {
    id: string;
    name: string;
    purpose: string;
    subject: string;
    body: string;
    triggerEvent: string;
    isActive: boolean;
    updatedAt: number;
    stats: {
      id: string;
      sentCount: number;
      openCount: number;
      clickCount: number;
      bounceCount: number;
      lastSentAt: number | null;
    };
  };
}
